<template>
  <div style="display: none;"></div>
</template>
<script>
  export default {
    props: {
      params: {
        type: Object
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/blank.vue